module.exports = __webpack_public_path__ + "static/media/13_3.28d8688f.jpg";